import { of } from 'rxjs';
import { FormInput, FormInputType } from '@shared/models';
import { Column, ColumnType } from '@shared/components/simple-table/models/simple-table-model';
import { BankService } from '@shared/services/bank.service';

export function getCurrentAccountInputs(bankService: BankService): FormInput[] {
  return [
    {
      name: 'Banco',
      formControlName: 'banco',
      type: FormInputType.SELECT,
      select: bankService.getAsSelectOptions(),
      class: 'col-6',
    },
    {
      name: 'Agência',
      formControlName: 'agencia',
      type: FormInputType.TEXT,
      mask: '0000 || 0000-0',
      class: 'col-3',
    },
    {
      name: 'Conta',
      formControlName: 'conta',
      type: FormInputType.TEXT,
      class: 'col-3',
    },
    {
      name: 'Tipo de Conta',
      formControlName: 'tipoConta',
      type: FormInputType.SELECT,
      select: of([
        { label: 'Corrente', value: 1 },
        { label: 'Poupança', value: 2 },
        { label: 'Selic', value: 3 },
        { label: 'Cetip', value: 4 },
      ]),
      class: 'col-4',
    },
    {
      name: 'Chave Pix',
      formControlName: 'chavePix',
      type: FormInputType.TEXT,
      class: 'col-8',
    },
  ];
}

export const currentAccountTableColumns: Column[] = [
  { name: 'Banco', id: 'banco', type: ColumnType.SELECT_DATA },
  { name: 'Agência', id: 'agencia', type: ColumnType.NAME },
  { name: 'Conta', id: 'conta', type: ColumnType.NAME },
  { name: 'Tipo de Conta', id: 'tipoConta', type: ColumnType.SELECT_DATA },
  { name: 'Chave Pix', id: 'chavePix', type: ColumnType.NAME },
];